import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { contractorPersonFormLabel } from "../Constant";

function ViewBasicDetailsComponent({ form }) {
  return (
    <div>
      <h5>Basic Details</h5>
      <Row>
        <Col md={4}>
          <h5>{contractorPersonFormLabel["firstName"]}</h5>
          <p>{form?.firstName}</p>
        </Col>
        <Col md={4}>
          <h5>{contractorPersonFormLabel["middleName"]}</h5>
          <p>{form?.middleName}</p>
        </Col>
        <Col md={4}>
          <h5>{contractorPersonFormLabel["lastName"]}</h5>
          <p>{form?.lastName}</p>
        </Col>
        <Col md={4}>
          <h5>{contractorPersonFormLabel["authorizedPerson"]}</h5>
          <p>{form?.authorizedPerson}</p>
        </Col>
        <Col md={4}>
          <h5>{contractorPersonFormLabel["laborLicenseNo"]}</h5>
          <p>{form?.laborLicenseNo}</p>
        </Col>
        <Col md={4}>
          <h5>{contractorPersonFormLabel["mobileNumber"]}</h5>
          <p>{form?.mobileNumber}</p>
        </Col>
        <Col md={4}>
          <h5>{contractorPersonFormLabel["aadharNumber"]}</h5>
          <p>{form?.aadharNumber}</p>
        </Col>
        <Col md={4}>
          <h5>{contractorPersonFormLabel["dob"]}</h5>
          <p>{form?.dob ? DDMMYYYYFormat(form?.dob) : ""}</p>
        </Col>
        <Col md={4}>
          <h5>{contractorPersonFormLabel["gender"]}</h5>
          <p>{form?.gender}</p>
        </Col>
        <Col md={4}>
          <h5>{contractorPersonFormLabel["designation"]}</h5>
          <p>{form?.designation}</p>
        </Col>
        <Col md={4}>
          <h5>{contractorPersonFormLabel["dateOfJoining"]}</h5>
          <p>{form?.dateOfJoining ? DDMMYYYYFormat(form?.dateOfJoining) : ""}</p>
        </Col>
      </Row>
    </div>
  );
}

export default ViewBasicDetailsComponent;
